import { render, staticRenderFns } from "./CommentList.vue?vue&type=template&id=2bfe783a&scoped=true&"
import script from "./CommentList.vue?vue&type=script&lang=ts&"
export * from "./CommentList.vue?vue&type=script&lang=ts&"
import style0 from "./CommentList.vue?vue&type=style&index=0&id=2bfe783a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfe783a",
  null
  
)

export default component.exports